<template>
	<EventPackLayout :event="event">
		<Empty v-if="packs.length === 0"/>
		<CardGrid v-else tight>
			<Card v-for="pack in packs" :key="`packs-${pack.id}`" :title="pack.title" :subtitle="trans(`events.activities.types.${pack.type}`)">
				<template #badges>
					<Badge v-if="pack.active" :color="Color.Green" active>{{ trans('general.enabled') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.disabled') }}</Badge>
					<Badge class="cursor-pointer" @click.stop="copyTextToClipboard(pack.id)">#{{ pack.id }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('events.activities.title') }}</template>
					<p>{{ pack.activities_count }}</p>
				</LabeledObject>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('events.packs.edit', {event: event.id, pack: pack.id})">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
					<SoftButton :color="Color.Red" @click.stop="remove(pack)">
						<i class="fa-solid fa-trash mr-2"/>
						{{ trans('general.delete') }}
					</SoftButton>
				</template>
			</Card>
		</CardGrid>
	</EventPackLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import {defineProps, ref, type Ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {type Pack} from '@/Types/Events/Packs/Pack'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import EventPackLayout from '@/Layouts/EventPackLayout.vue'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {copyTextToClipboard, showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	event:Event,
	packs:Array<Pack>,
}>()

const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const packs:Ref<Array<Pack>> = ref(props.packs)

function remove(pack:Pack):void{
	if(!working.value && confirm(trans('general.confirm_action'))){
		working.value = true
		showInfo(trans('general.deleting'))
		axios.delete(route('events.packs.destroy', {event: event.value.id, pack: pack.id})).then(() => {
			showSuccess(trans('general.deleted'))
			const index = packs.value.findIndex((p:Pack) => p.id === pack.id)
			if(index > -1){
				packs.value.splice(index, 1)
			}
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>